import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import type { UserRole } from "@/lib/types";
import LoadingState from "./LoadingState";

/**
 * Client-side soft gate. The real authorization is in RLS on the V2
 * schema — this just prevents flashing pages the user can't use.
 *
 * If you find yourself adding more options here, ask whether the RLS
 * policy can express the same thing and let the empty result render the
 * page in a no-data state instead.
 */
export default function RequireRole({
  allow,
  children,
}: {
  allow: UserRole[];
  children: React.ReactNode;
}) {
  const { role, loading } = useAuth();

  if (loading) return <LoadingState label="Checking permissions…" />;
  if (!role) return <Navigate to="/login" replace />;
  if (!allow.includes(role)) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
